import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '../../../../../../../../components/Common/UI/Dialog';
import { cn } from '../../../../../../../../utils/styles';
import Icons from '../../../../../../../../components/Common/Icons/Icons';
import { IModalProps } from '../../Select';
import { Input } from '../../../../../../../../components/Common/UI/Input';
import { Button } from '../../../../../../../../components/Common/UI/Button';
import DataTable from '../../../../../../../../components/Common/UI/DataTable';
import { IUserLinkColRes, linkData, userLinkCol } from '../Data';

function ModalLinkUser({ open, handleOpen }: IModalProps) {
  const [state, setState] = useState<IUserLinkColRes[]>(linkData);
  const [search, setSearch] = useState<string>('');
  const [showResult, setShowResult] = useState<boolean>(false);

  const handleSearch = (payload: string) => {
    setSearch(payload);
  };

  const handleSearchResult = () => {
    setShowResult(true);
    const newData = linkData.filter(el => el.username.includes(search));

    setState(newData);
  };

  return (
    <Dialog open={open} onOpenChange={e => handleOpen(e, 'link')}>
      <DialogContent className={cn('max-h-[98%] max-w-[710px] bg-[#F8F9FD]')}>
        <DialogTitle className="mb-[10px] font-normal text-[16px] flex gap-[20px] items-start">
          <div className="bg-[#307BB2] p-[5px] rounded-lg w-[35px] h-[35px] flex items-center justify-center">
            <Icons.Newspaper className="[&_path]:fill-white w-[20px] h-[20px]" />
          </div>
          <div className="font-bold text-xl leading-[24px] mt-[5px]">Link User</div>
        </DialogTitle>
        <div className="grid gap-[20px]">
          <div className="bg-white p-[20px] flex items-start gap-[35px] border">
            <Input
              variant="search"
              inputClassName="w-[375px]"
              placeholder="Type to Search"
              onChange={e => handleSearch(e.target.value)}
              value={search}
              icon={<Icons.Search />}
              maxLength={75}
            />
            <Button onClick={handleSearchResult}>Search</Button>
          </div>
          <div>
            <div className="bg-[#284F6612] px-[20px] mb-[10px] py-[10px] text-primary text-center font-bold">
              Search Result:
            </div>
            <DataTable
              paginationPosition="bottom"
              columns={userLinkCol}
              data={showResult ? state : []}
              initialState={{ pagination: { pageSize: 4 } }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModalLinkUser;
